import { authDevToolsSlice } from './authDevTools.slice';

export const AUTH_DEV_TOOLS_REDUCER_KEY = authDevToolsSlice.name;
export const authDevToolsReducer = authDevToolsSlice.reducer;
